// extracted by mini-css-extract-plugin
export default {"navigation":"navigation_navigation__+uQih","active":"navigation_active__qZkFS"};